// Home: Weekly quests card (src/core/quests.js) and the one-time "quest week complete" toast.
import { h } from './h.js';
import { play } from './sound.js';
import { weekRangeLabel } from '../core/weekly.js';

/** @param {{ board: ReturnType<import('../core/quests.js').questBoard>, stats: { weeks:number, streak:number } }} o */
export function questCard({ board, stats }) {
  const done = board.quests.filter((q) => q.done).length;
  return h('section', { class: `rz-quests panel${board.complete ? ' complete' : ''}`, 'data-testid': 'home-quests', 'aria-labelledby': 'rz-quests-title' },
    h('div', { class: 'rz-quests-head' },
      h('div', {}, h('div', { class: 'eyebrow' }, `WEEKLY QUESTS · ${weekRangeLabel(board.start).toUpperCase()}`),
        h('h2', { id: 'rz-quests-title' }, board.complete ? 'Quest week complete!' : 'This week’s quests')),
      h('span', { class: 'rz-quests-meta', 'data-testid': 'quests-meta' },
        board.complete ? `✓ ${done} / ${board.quests.length} done` : `${done} / ${board.quests.length} done · ${board.daysLeft} day${board.daysLeft === 1 ? '' : 's'} left`)),
    h('ul', { class: 'rz-quest-list' }, board.quests.map((q) => h('li', { class: `rz-quest${q.done ? ' done' : ''}`, 'data-testid': `quest-${q.id}`, 'data-done': q.done ? 'true' : 'false' },
      h('span', { class: 'rz-quest-icon', 'aria-hidden': 'true' }, q.done ? '✓' : q.icon),
      h('span', { class: 'rz-quest-main' }, h('b', {}, q.title),
        h('span', { class: 'rz-quest-bar', role: 'progressbar', 'aria-valuenow': q.value, 'aria-valuemin': 0, 'aria-valuemax': q.target, 'aria-label': q.title }, h('i', { style: { width: `${Math.round((q.value / q.target) * 100)}%` } }))),
      h('span', { class: 'rz-quest-count mono' }, `${q.value.toLocaleString()} / ${q.target.toLocaleString()}${q.unit ? ` ${q.unit}` : ''}`)))),
    h('p', { class: 'rz-quests-foot muted small', 'data-testid': 'quests-stats' },
      stats.weeks ? `Quest weeks completed: ${stats.weeks}${stats.streak > 1 ? ` · 🔥 ${stats.streak}-week streak` : ''}. ` : '',
      'New quests every Monday. Quests count only verified missions, tickets and daily challenges; XP still comes from missions and tickets.'));
}

/** One-time celebration when all three quests of a week are done. */
export function questToast() {
  let stack = document.querySelector('.rz-reward-stack');
  if (!stack) { stack = h('div', { class: 'rz-reward-stack', role: 'status', 'aria-live': 'polite' }); document.body.append(stack); }
  const t = h('div', { class: 'rz-reward-toast level', 'data-testid': 'quest-toast' }, h('span', { class: 'rz-reward-k' }, 'WEEKLY QUESTS'), h('b', {}, 'Quest week complete!'));
  stack.append(t);
  play('levelup');
  requestAnimationFrame(() => t.classList.add('show'));
  setTimeout(() => { t.classList.remove('show'); setTimeout(() => t.remove(), 400); }, 4200);
  return t;
}
